export function checkoutAuth() {
  jQuery(document).on("click", ".signup-button, .signin-button", function (e) {
    e.preventDefault();

    const templateToLoad = jQuery(this).data("template");

    jQuery.ajax({
      url: my_ajax_object.ajax_url,
      method: "POST",
      dataType: "json",
      data: {
        action: "load_auth_template",
        template: templateToLoad,
      },
      success: function (response) {
        if (response.success) {
          jQuery(".boxConteudo").hide();
          jQuery("#authContainer").html(response.data.html);
        } else {
          console.log("Erro:", response.data);
        }
      },
      error: function (error) {
        console.log("Erro na requisição AJAX:", error);
      },
    });
  });
}
